import { put, take, call, fork } from "redux-saga/effects";
import {
  disableScopeLoading,
  enableScopeLoading,
} from "../scope-loading/actions";
import { ClaimAction, ClaimScope } from "./types";
import { ScopeErrorAction } from "../scope-error/types";
import * as Api from "../../service/api";
import { navigateTo } from "../../helper";
import RouteNames from "../../routes/type";

function* submitClaimFlow() {
  while (true) {
    const request = yield take(ClaimAction.SUBMIT_CLAIM);
    yield put(enableScopeLoading(ClaimScope));
    try {
      const contact_email =
        request?.payload?.customer_info?.email || "no@email.com";
      const data = yield call(Api.deskTicket.claimTicket, {
        contact_email,
        data: request.payload,
      });
      yield navigateTo(
        `${RouteNames.CREATE_CLAIM}?step=6&ticket=${data?.ticketNumber}`
      );
    } catch (error) {
      yield put({
        type: ScopeErrorAction.SET_SCOPE_ERROR,
        payload: ClaimScope,
        error,
      });
    } finally {
      yield put(disableScopeLoading(ClaimScope));
    }
  }
}
export default function* userSaga() {
  yield fork(submitClaimFlow);
}
